import useCheckPC from "@repo/hooks/utils/useCheckPC";
import classNames from "classnames";
import React from "react";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";

interface IProps {
  title: string;
  handleShowList: () => void;
  showList: boolean;
  children: React.ReactNode;
}

function FilterList({ title, handleShowList, showList, children }: IProps) {
  const { isPC } = useCheckPC();

  return (
    <div className="flex flex-col gap-5">
      <button
        className="w-fit uppercase"
        onClick={() => {
          handleShowList();
        }}
      >
        {title}
      </button>
      <ul className={classNames("flex flex-col gap-5 pb-2.5 pl-2.5 pc:gap-2.5", !showList && "hidden")}>
        <SimpleBar autoHide={false} style={isPC ? { maxHeight: 436 } : { maxHeight: 320 }}>
          {children}
        </SimpleBar>
      </ul>
    </div>
  );
}

export default FilterList;
